document.addEventListener("DOMContentLoaded", function () {
  // Tijdelijke acties (bv. Black Friday): alleen tonen binnen de periode in data-actie-van/-tot (snippets/black-friday.liquid).
  var nu = Date.now();
  document.querySelectorAll("[data-actie-van]").forEach(function (el) {
    if (nu >= Date.parse(el.getAttribute("data-actie-van")) && nu <= Date.parse(el.getAttribute("data-actie-tot"))) el.hidden = false;
  });

  // Verwachte bezorgdatum op de productpagina: vandaag + 1 tot 2 werkdagen (zelfde belofte als "Levering in 1 à 2
  // werkdagen met DHL"), zonder weekend en Nederlandse feestdagen. Bewust "verwacht": de leverancier verzendt doorgaans binnen 1 werkdag.
  var bezorg = document.querySelector("[data-bezorgdatum]");
  if (bezorg) {
    var feestdagen = ["2026-12-25", "2026-12-26", "2027-01-01", "2027-03-28", "2027-03-29", "2027-04-27", "2027-05-05", "2027-05-06", "2027-05-16", "2027-05-17", "2027-12-25", "2027-12-26"];
    var iso = function (d) { return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2); };
    var werkdagErbij = function (d) {
      var x = new Date(d.getTime());
      do { x.setDate(x.getDate() + 1); } while (x.getDay() === 0 || x.getDay() === 6 || feestdagen.indexOf(iso(x)) !== -1);
      return x;
    };
    var vroegst = werkdagErbij(new Date());
    var laatst = werkdagErbij(vroegst);
    var dagen = ["zo", "ma", "di", "wo", "do", "vr", "za"];
    var maanden = ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"];
    var kort = function (d, metMaand) { return dagen[d.getDay()] + " " + d.getDate() + (metMaand ? " " + maanden[d.getMonth()] : ""); };
    var zelfdeMaand = vroegst.getMonth() === laatst.getMonth();
    // In één span: .product-levering p is een flexbox, losse tekst + strong zouden anders als aparte blokjes onder elkaar komen.
    bezorg.innerHTML = "<span>Verwacht in huis: <strong>" + kort(vroegst, !zelfdeMaand) + " – " + kort(laatst, true) + "</strong> · met DHL</span>";
  }

  // Mobiel menu: openen/sluiten met de knop, Escape of een klik buiten het menu.
  var hamburger = document.querySelector(".hamburger");
  var mobileNav = document.querySelector(".mobile-nav");
  if (hamburger && mobileNav) {
    var setMenu = function (open, focusButton) {
      mobileNav.classList.toggle("open", open);
      hamburger.setAttribute("aria-expanded", open ? "true" : "false");
      hamburger.setAttribute("aria-label", open ? "Menu sluiten" : "Menu");
      if (open) {
        // Focus op de eerste link, niet op het zoekveld: anders springt op telefoons meteen het toetsenbord open.
        var first = mobileNav.querySelector("a");
        if (first) first.focus({ preventScroll: true });
      } else if (focusButton) {
        hamburger.focus();
      }
    };
    hamburger.addEventListener("click", function () {
      setMenu(!mobileNav.classList.contains("open"), false);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && mobileNav.classList.contains("open")) setMenu(false, true);
    });
    document.addEventListener("click", function (e) {
      if (mobileNav.classList.contains("open") && !mobileNav.contains(e.target) && !hamburger.contains(e.target)) setMenu(false, false);
    });
  }

  // Filterrij op de collectiepagina: scroll de gekozen soort in beeld als de rij opzij scrolt.
  var actieveChip = document.querySelector(".filter-chips .filter-chip.is-active");
  if (actieveChip) {
    var chipRij = actieveChip.closest("ul");
    if (chipRij && chipRij.scrollWidth > chipRij.clientWidth) {
      chipRij.scrollLeft = actieveChip.offsetLeft - chipRij.offsetLeft - 24;
    }
  }

  // Productpagina (computer): schuif onderdelen van de beschrijving (Gebruik, Samenstelling…) naar de linkerkolom
  // onder de foto's zolang dat de kolommen gelijker maakt. "Voordelen" blijft altijd rechts, de volgorde blijft gelijk.
  var specsLinks = document.querySelector(".product-detail-specs");
  var descRechts = document.querySelector(".product-detail-info .product-detail-desc");
  if (specsLinks && descRechts && window.matchMedia("(min-width: 901px)").matches) {
    var balanceer = function () {
      var groepen = [];
      var huidig = null;
      Array.prototype.forEach.call(descRechts.children, function (el) {
        if (el.tagName === "H3") { huidig = [el]; groepen.push(huidig); }
        else if (huidig) { huidig.push(el); }
      });
      groepen.shift();
      var gallery = document.querySelector(".product-gallery");
      var info = document.querySelector(".product-detail-info");
      var hoogte = function (els) {
        return els.reduce(function (som, el) {
          var cs = getComputedStyle(el);
          return som + el.offsetHeight + parseFloat(cs.marginTop) + parseFloat(cs.marginBottom);
        }, 0);
      };
      for (var i = 0; i < groepen.length; i++) {
        var links = Math.max(gallery.getBoundingClientRect().bottom, specsLinks.getBoundingClientRect().bottom);
        var rechts = info.getBoundingClientRect().bottom;
        var h = hoogte(groepen[i]);
        if (Math.abs(links + h - (rechts - h)) >= Math.abs(links - rechts)) break;
        groepen[i].forEach(function (el) { specsLinks.appendChild(el); });
      }
    };
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(balanceer); } else { balanceer(); }
  } else if (specsLinks && descRechts) {
    // Telefoon: Specificaties terug op de vaste plek, direct na de Voordelen.
    var tweedeKop = descRechts.querySelectorAll("h3")[1] || null;
    Array.prototype.slice.call(specsLinks.children).forEach(function (el) { descRechts.insertBefore(el, tweedeKop); });
    specsLinks.hidden = true;
  }

  // Laad de herovideo alleen op bredere schermen, zodat mobiel nooit het videobestand downloadt.
  // Pas na het laden van de pagina, zodat de video niet concurreert met de herofoto en de rest van de pagina.
  var heroVideo = document.querySelector(".hero-video-bg[data-video-src]");
  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var saveDataVideo = navigator.connection && navigator.connection.saveData;
  if (heroVideo && !prefersReducedMotion && !saveDataVideo && window.matchMedia("(min-width: 761px)").matches) {
    var startVideo = function () {
      // De video wordt beeldje voor beeldje op een canvas getekend. Chrome op Windows toont een video
      // tijdens scrollen in andere kleuren dan bij stilstand; een canvas heeft dat niet.
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext && canvas.getContext("2d");
      var drawing = false;
      var lastTime = -1;
      var draw = function () {
        // Alleen tekenen als er een nieuw beeldje is (de video staat stil buiten beeld of in een ander tabblad).
        if (heroVideo.videoWidth && heroVideo.currentTime !== lastTime) {
          lastTime = heroVideo.currentTime;
          if (canvas.width !== heroVideo.videoWidth) {
            canvas.width = heroVideo.videoWidth;
            canvas.height = heroVideo.videoHeight;
          }
          ctx.drawImage(heroVideo, 0, 0, canvas.width, canvas.height);
        }
        window.requestAnimationFrame(draw);
      };
      if (ctx) {
        canvas.className = "hero-video-canvas";
        canvas.setAttribute("aria-hidden", "true");
        heroVideo.insertAdjacentElement("afterend", canvas);
      }
      // Pas tonen zodra de video echt speelt; tot die tijd blijft de foto eronder zichtbaar.
      heroVideo.addEventListener("playing", function () {
        if (!ctx) { heroVideo.classList.add("is-playing"); return; }
        if (!drawing) { drawing = true; draw(); }
        canvas.classList.add("is-playing");
      });
      var source = document.createElement("source");
      source.src = heroVideo.getAttribute("data-video-src");
      source.type = "video/mp4";
      heroVideo.appendChild(source);
      heroVideo.load();
      heroVideo.play().catch(function () {
        /* autoplay kan geblokkeerd worden; de foto onder de video blijft dan zichtbaar */
      });
    };
    if (document.readyState === "complete") startVideo();
    else window.addEventListener("load", startVideo);
  }

  // Productfoto's: alle grote foto's staan gestapeld; wisselen = alleen een andere zichtbaar maken.
  // Op de computer worden ze na het laden van de pagina allemaal opgehaald (wisselen gaat dan direct);
  // op een telefoon alleen de foto's naast de getoonde, om mobiele data te sparen.
  var gallery = document.querySelector("[data-gallery]");
  var showSlideByMediaId = null;
  if (gallery) {
    var slides = gallery.querySelectorAll(".gallery-slide");
    var thumbs = document.querySelectorAll(".product-thumb");
    var counter = gallery.querySelector("[data-gallery-current]");
    var current = 0;

    var loadSlide = function (slide) {
      if (!slide) return;
      if (slide.hasAttribute("data-srcset")) {
        slide.srcset = slide.getAttribute("data-srcset");
        slide.removeAttribute("data-srcset");
      }
      if (slide.hasAttribute("data-src")) {
        slide.src = slide.getAttribute("data-src");
        slide.removeAttribute("data-src");
      }
    };

    var show = function (index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === current;
        if (active) loadSlide(slide);
        slide.classList.toggle("is-active", active);
        slide.setAttribute("aria-hidden", active ? "false" : "true");
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle("is-active", i === current);
        if (i === current) {
          thumb.setAttribute("aria-current", "true");
          if (thumb.scrollIntoView && thumb.parentElement.parentElement.scrollWidth > thumb.parentElement.parentElement.clientWidth) {
            thumb.scrollIntoView({ block: "nearest", inline: "nearest" });
          }
        } else {
          thumb.removeAttribute("aria-current");
        }
      });
      if (counter) counter.textContent = current + 1;
      // Buren alvast laden, voor het geval de bezoeker verder klikt of veegt.
      loadSlide(slides[(current + 1) % slides.length]);
      loadSlide(slides[(current - 1 + slides.length) % slides.length]);
    };

    showSlideByMediaId = function (mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute("data-media-id") === String(mediaId)) { show(i); return; }
      }
    };

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener("click", function () { show(i); });
      thumb.addEventListener("mouseenter", function () { loadSlide(slides[i]); });
    });
    gallery.querySelectorAll("[data-gallery-step]").forEach(function (button) {
      button.addEventListener("click", function () {
        show(current + parseInt(button.getAttribute("data-gallery-step"), 10));
      });
    });

    // Pijltjestoetsen als de focus in de fotogalerij staat.
    gallery.closest(".product-gallery").addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") { show(current - 1); e.preventDefault(); }
      if (e.key === "ArrowRight") { show(current + 1); e.preventDefault(); }
    });

    // Vegen op een telefoon: links/rechts over de foto.
    var touchX = null;
    var touchY = null;
    gallery.addEventListener("touchstart", function (e) {
      touchX = e.touches[0].clientX;
      touchY = e.touches[0].clientY;
    }, { passive: true });
    gallery.addEventListener("touchend", function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      var dy = e.changedTouches[0].clientY - touchY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1));
      touchX = null;
    }, { passive: true });

    var saveData = navigator.connection && navigator.connection.saveData;
    var isPhone = window.matchMedia("(hover: none) and (max-width: 900px)").matches;
    var loadAll = function () { slides.forEach(loadSlide); };
    var loadNeighbours = function () { loadSlide(slides[1]); loadSlide(slides[slides.length - 1]); };
    var afterLoad = (isPhone || saveData) ? loadNeighbours : loadAll;
    if (document.readyState === "complete") afterLoad();
    else window.addEventListener("load", afterLoad);
  }

  // Foto groot bekijken: tik of klik op de getoonde productfoto (of op de vergrootknop).
  // Een scherm over de hele pagina met de grote foto, pijltjes, vegen en Esc om te sluiten.
  var photoBox = document.querySelector(".product-detail-img");
  if (photoBox) {
    var photoSlides = photoBox.querySelectorAll(".gallery-slide");
    var viewer = null;
    var viewerImg = null;
    var viewerCount = null;
    var viewerIndex = 0;
    var viewerReturn = null;

    var largeSrc = function (slide) {
      var src = slide.getAttribute("src") || slide.getAttribute("data-src") || "";
      return src.replace(/width=\d+/, "width=1600");
    };

    var viewerShow = function (index) {
      viewerIndex = (index + photoSlides.length) % photoSlides.length;
      var slide = photoSlides[viewerIndex];
      viewerImg.src = largeSrc(slide);
      viewerImg.alt = slide.alt;
      if (viewerCount) viewerCount.textContent = (viewerIndex + 1) + "/" + photoSlides.length;
    };

    var viewerClose = function () {
      if (!viewer) return;
      viewer.hidden = true;
      document.documentElement.classList.remove("foto-open");
      document.removeEventListener("keydown", viewerKeys);
      // De getoonde foto op de pagina volgt de foto die je in het groot zag.
      if (typeof showSlideByMediaId === "function") {
        showSlideByMediaId(photoSlides[viewerIndex].getAttribute("data-media-id"));
      }
      if (viewerReturn && viewerReturn.focus) viewerReturn.focus();
    };

    var viewerKeys = function (e) {
      if (e.key === "Escape") { viewerClose(); e.preventDefault(); return; }
      if (e.key === "ArrowLeft" && photoSlides.length > 1) { viewerShow(viewerIndex - 1); e.preventDefault(); return; }
      if (e.key === "ArrowRight" && photoSlides.length > 1) { viewerShow(viewerIndex + 1); e.preventDefault(); return; }
      if (e.key === "Tab") {
        // Focus blijft binnen het scherm.
        var items = viewer.querySelectorAll("button");
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
      }
    };

    var viewerBuild = function () {
      var many = photoSlides.length > 1;
      viewer = document.createElement("div");
      viewer.className = "foto-box";
      viewer.setAttribute("role", "dialog");
      viewer.setAttribute("aria-modal", "true");
      viewer.setAttribute("aria-label", "Productfoto vergroot");
      viewer.hidden = true;
      viewer.innerHTML =
        '<button type="button" class="foto-box-sluit" aria-label="Sluiten">&times;</button>' +
        '<img class="foto-box-img" alt="">' +
        (many
          ? '<button type="button" class="foto-box-pijl foto-box-pijl--vorige" aria-label="Vorige foto">&lsaquo;</button>' +
            '<button type="button" class="foto-box-pijl foto-box-pijl--volgende" aria-label="Volgende foto">&rsaquo;</button>' +
            '<span class="foto-box-teller" aria-hidden="true"></span>'
          : "");
      document.body.appendChild(viewer);
      viewerImg = viewer.querySelector(".foto-box-img");
      viewerCount = viewer.querySelector(".foto-box-teller");
      viewer.querySelector(".foto-box-sluit").addEventListener("click", viewerClose);
      if (many) {
        viewer.querySelector(".foto-box-pijl--vorige").addEventListener("click", function () { viewerShow(viewerIndex - 1); });
        viewer.querySelector(".foto-box-pijl--volgende").addEventListener("click", function () { viewerShow(viewerIndex + 1); });
      }
      // Tik naast de foto sluit het scherm.
      viewer.addEventListener("click", function (e) { if (e.target === viewer) viewerClose(); });
      var startX = null;
      var startY = null;
      viewer.addEventListener("touchstart", function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });
      viewer.addEventListener("touchend", function (e) {
        if (startX === null || !many) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) viewerShow(viewerIndex + (dx < 0 ? 1 : -1));
        startX = null;
      }, { passive: true });
    };

    var viewerOpen = function (index, trigger) {
      if (!viewer) viewerBuild();
      viewerReturn = trigger || document.activeElement;
      viewerShow(index);
      viewer.hidden = false;
      document.documentElement.classList.add("foto-open");
      document.addEventListener("keydown", viewerKeys);
      viewer.querySelector(".foto-box-sluit").focus();
    };

    photoBox.addEventListener("click", function (e) {
      var zoomButton = e.target.closest(".gallery-zoom");
      var slide = e.target.closest(".gallery-slide");
      if (zoomButton) {
        var shown = 0;
        photoSlides.forEach(function (s, i) { if (s.classList.contains("is-active")) shown = i; });
        viewerOpen(shown, zoomButton);
      } else if (slide && slide.classList.contains("is-active")) {
        viewerOpen(Array.prototype.indexOf.call(photoSlides, slide), slide);
      }
    });
  }

  // Aantal: − en + knoppen, binnen de grenzen van het invoerveld.
  // In de winkelwagen (data-auto-update) wordt de winkelwagen meteen bijgewerkt.
  document.querySelectorAll("[data-qty]").forEach(function (box) {
    var input = box.querySelector("input");
    var buttons = box.querySelectorAll("[data-qty-step]");
    var autoUpdate = input.hasAttribute("data-auto-update");
    var timer = null;
    function clamp(value) {
      var min = parseInt(input.min, 10);
      if (isNaN(min)) min = 1;
      var max = parseInt(input.max, 10) || 99;
      var number = parseInt(value, 10);
      if (isNaN(number)) number = min;
      return Math.min(max, Math.max(min, number));
    }
    function refresh() {
      var value = clamp(input.value);
      input.value = value;
      buttons.forEach(function (button) {
        var step = parseInt(button.getAttribute("data-qty-step"), 10);
        button.disabled = clamp(value + step) === value;
      });
    }
    function scheduleUpdate() {
      if (!autoUpdate) return;
      clearTimeout(timer);
      timer = setTimeout(function () { input.form.submit(); }, 600);
    }
    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        input.value = clamp(input.value) + parseInt(button.getAttribute("data-qty-step"), 10);
        refresh();
        input.dispatchEvent(new Event("input", { bubbles: true }));
        scheduleUpdate();
      });
    });
    input.addEventListener("change", function () { refresh(); scheduleUpdate(); });
    refresh();
  });

  // Productprijs: stukprijs x aantal. Bij 2 of meer staat de stukprijs klein achter het totaal.
  var priceBox = document.querySelector("[data-unit-price]");
  var priceEls = document.querySelectorAll("[data-product-price]");
  var priceEach = document.querySelector("[data-price-each]");
  var qtyInput = document.querySelector('#product-form input[name="quantity"]');
  // Bedrag in centen volgens de geldnotatie van de winkel (bv. "€{{amount_with_comma_separator}}").
  var formatMoney = function (cents) {
    var format = (priceBox && priceBox.getAttribute("data-money-format")) || "€{{amount_with_comma_separator}}";
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = match ? match[1] : "amount";
    var comma = kind.indexOf("comma") > -1;
    var parts = (cents / 100).toFixed(kind.indexOf("no_decimals") > -1 ? 0 : 2).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? "." : ",");
    return format.replace(/\{\{\s*\w+\s*\}\}/, parts.join(comma ? "," : "."));
  };
  var updatePrice = function () {
    if (!priceBox) return;
    var unit = parseInt(priceBox.getAttribute("data-unit-price"), 10);
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    priceEls.forEach(function (el) { el.textContent = formatMoney(unit * qty); });
    if (priceEach) {
      priceEach.hidden = qty < 2;
      priceEach.textContent = qty < 2 ? "" : "(" + qty + " × " + formatMoney(unit) + ")";
    }
  };
  if (qtyInput) {
    qtyInput.addEventListener("input", updatePrice);
    qtyInput.addEventListener("change", updatePrice);
    updatePrice();
  }

  // Voorraadregel en maximum aantal voor de gekozen variant (data-voorraad is leeg als de voorraad niet telt).
  var stockText = document.querySelector("[data-voorraad-tekst]");
  var updateStock = function (radio) {
    var stock = parseInt(radio.getAttribute("data-voorraad"), 10);
    var counted = !isNaN(stock);
    if (qtyInput) {
      qtyInput.max = counted ? Math.min(99, Math.max(1, stock)) : 99;
      qtyInput.dispatchEvent(new Event("change"));
    }
    if (stockText) {
      var low = counted && stock <= 3;
      stockText.classList.toggle("is-laag", low);
      stockText.textContent = low ? "Nog maar " + stock + " op voorraad" : "Op voorraad";
    }
  };

  // Maatkeuze: prijs, voorraad, foto en adres (?variant=) van de gekozen variant tonen.
  document.querySelectorAll(".variant-option input").forEach(function (radio) {
    radio.addEventListener("change", function () {
      if (!radio.checked) return;
      if (priceBox) priceBox.setAttribute("data-unit-price", radio.getAttribute("data-price"));
      updateStock(radio);
      updatePrice();
      if (showSlideByMediaId && radio.getAttribute("data-media-id")) showSlideByMediaId(radio.getAttribute("data-media-id"));
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", radio.value);
        window.history.replaceState({}, "", url.toString());
      }
    });
  });

  // Sorteren: direct toepassen bij een keuze.
  document.querySelectorAll("[data-auto-submit]").forEach(function (select) {
    select.addEventListener("change", function () { select.form.submit(); });
  });

  // Sorteren: vervang de gewone select door een eigen uitklapmenu in de huisstijl (listbox, ook met toetsenbord).
  var sortSelect = document.querySelector(".sort-form select");
  if (sortSelect) {
    var sortLabel = document.querySelector('label[for="' + sortSelect.id + '"]');
    var wrap = document.createElement("div");
    wrap.className = "sort-dropdown";
    var toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = "sort-toggle";
    toggle.id = sortSelect.id + "Toggle";
    toggle.setAttribute("aria-haspopup", "listbox");
    toggle.setAttribute("aria-expanded", "false");
    var toggleText = document.createElement("span");
    toggleText.id = sortSelect.id + "Tekst";
    toggle.appendChild(toggleText);
    var list = document.createElement("ul");
    list.className = "sort-list";
    list.id = sortSelect.id + "Lijst";
    list.setAttribute("role", "listbox");
    list.tabIndex = -1;
    list.hidden = true;
    toggle.setAttribute("aria-controls", list.id);
    if (sortLabel) {
      sortLabel.id = sortSelect.id + "Label";
      sortLabel.htmlFor = toggle.id;
      toggle.setAttribute("aria-labelledby", sortLabel.id + " " + toggleText.id);
      list.setAttribute("aria-labelledby", sortLabel.id);
    }

    var items = Array.prototype.map.call(sortSelect.options, function (opt, i) {
      var li = document.createElement("li");
      li.id = list.id + "-" + i;
      li.setAttribute("role", "option");
      li.setAttribute("aria-selected", opt.selected ? "true" : "false");
      li.textContent = opt.textContent;
      li.dataset.value = opt.value;
      list.appendChild(li);
      return li;
    });
    var activeIndex = Math.max(sortSelect.selectedIndex, 0);
    toggleText.textContent = sortSelect.options[activeIndex].textContent;

    var setActive = function (i) {
      activeIndex = (i + items.length) % items.length;
      items.forEach(function (li, j) { li.classList.toggle("is-active", j === activeIndex); });
      list.setAttribute("aria-activedescendant", items[activeIndex].id);
    };
    var openList = function () {
      list.hidden = false;
      toggle.setAttribute("aria-expanded", "true");
      setActive(Math.max(sortSelect.selectedIndex, 0));
      list.focus();
    };
    var closeList = function (focusToggle) {
      list.hidden = true;
      toggle.setAttribute("aria-expanded", "false");
      if (focusToggle) toggle.focus();
    };
    var choose = function (i) {
      closeList(true);
      if (i === sortSelect.selectedIndex) return;
      sortSelect.selectedIndex = i;
      toggleText.textContent = sortSelect.options[i].textContent;
      items.forEach(function (li, j) { li.setAttribute("aria-selected", j === i ? "true" : "false"); });
      sortSelect.form.submit();
    };

    toggle.addEventListener("click", function () {
      if (list.hidden) openList(); else closeList(true);
    });
    toggle.addEventListener("keydown", function (e) {
      if (e.key === "ArrowDown" || e.key === "ArrowUp") { e.preventDefault(); openList(); }
    });
    list.addEventListener("keydown", function (e) {
      if (e.key === "ArrowDown") { e.preventDefault(); setActive(activeIndex + 1); }
      else if (e.key === "ArrowUp") { e.preventDefault(); setActive(activeIndex - 1); }
      else if (e.key === "Home") { e.preventDefault(); setActive(0); }
      else if (e.key === "End") { e.preventDefault(); setActive(items.length - 1); }
      else if (e.key === "Enter" || e.key === " ") { e.preventDefault(); choose(activeIndex); }
      else if (e.key === "Escape") { e.preventDefault(); closeList(true); }
      else if (e.key === "Tab") { closeList(false); }
    });
    items.forEach(function (li, i) {
      li.addEventListener("click", function () { choose(i); });
      li.addEventListener("mousemove", function () { if (i !== activeIndex) setActive(i); });
    });
    document.addEventListener("click", function (e) {
      if (!list.hidden && !wrap.contains(e.target) && e.target !== sortLabel) closeList(false);
    });

    sortSelect.hidden = true;
    sortSelect.tabIndex = -1;
    wrap.appendChild(toggle);
    wrap.appendChild(list);
    sortSelect.parentNode.insertBefore(wrap, sortSelect.nextSibling);
  }

  // Vaste bestelbalk op telefoons: zichtbaar zolang de gewone knop niet in beeld is.
  var sticky = document.querySelector("[data-sticky-cart]");
  var mainButton = document.querySelector("[data-main-cart-button]");
  if (sticky && mainButton && "IntersectionObserver" in window) {
    var phone = window.matchMedia("(max-width: 900px)");
    var observer = new IntersectionObserver(function (entries) {
      var visible = phone.matches && !entries[0].isIntersecting;
      sticky.hidden = !visible;
      document.body.classList.toggle("has-sticky-cart", visible);
    });
    observer.observe(mainButton);
  }

  // Nieuwsbrief-pop-up (snippet nieuwsbrief-popup): na 20 s of halverwege scrollen, één keer per bezoek.
  // Verstuurt het nieuwsbriefformulier in de footer, zodat de bevestiging met kortingsknop daar verschijnt.
  var popup = document.querySelector("[data-nb-popup]");
  var footerForm = document.getElementById("nieuwsbrief-form");
  var footerEmail = footerForm && footerForm.querySelector('input[name="contact[email]"]');
  // Nieuwsbrief per doelgroep: gekozen dieren (hond/kat) als extra klanttags meesturen.
  if (footerForm) {
    footerForm.addEventListener("submit", function () {
      var tags = footerForm.querySelector('input[name="contact[tags]"]');
      if (!tags) return;
      var lijst = ["nieuwsbrief"];
      footerForm.querySelectorAll("[data-nb-dier]:checked").forEach(function (cb) { lijst.push(cb.value); });
      tags.value = lijst.join(",");
    });
  }
  var POPUP_KEY = "df-nb-popup";
  var readPopup = function () {
    try { return JSON.parse(localStorage.getItem(POPUP_KEY) || "null"); } catch (e) { return null; }
  };
  var savePopup = function (state) {
    try { localStorage.setItem(POPUP_KEY, JSON.stringify({ state: state, at: Date.now() })); } catch (e) {}
  };
  var popupBlocked = function () {
    var saved = readPopup();
    if (saved && (saved.state === "aangemeld" || Date.now() - saved.at < 14 * 24 * 60 * 60 * 1000)) return true;
    if (/(^|;\s*)discount_code=/.test(document.cookie)) return true; // er staat al een kortingscode klaar
    if (/customer_posted=true/.test(window.location.search)) { savePopup("aangemeld"); return true; }
    return false;
  };
  if (popup && footerForm && footerEmail && !popupBlocked()) {
    var shown = false;
    var waiting = false;
    var showPopup = function () {
      if (shown) return;
      // Cookiemelding van Shopify nog in beeld? Dan even wachten, zodat ze elkaar niet overlappen.
      var banner = document.getElementById("shopify-pc__banner");
      if (banner && banner.offsetParent !== null) {
        if (!waiting) { waiting = true; setTimeout(function () { waiting = false; showPopup(); }, 5000); }
        return;
      }
      shown = true;
      window.removeEventListener("scroll", onScroll);
      popup.hidden = false;
      requestAnimationFrame(function () { popup.classList.add("is-open"); });
    };
    var closePopup = function () {
      popup.classList.remove("is-open");
      popup.hidden = true;
      savePopup("gesloten");
    };
    var onScroll = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max > 0.5) showPopup();
    };
    var startPopupTimers = function () {
      setTimeout(showPopup, 20000);
      window.addEventListener("scroll", onScroll, { passive: true });
    };
    // Niet tegelijk met de cookiemelding: pas beginnen als de bezoeker daar een keuze heeft gemaakt.
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && privacy.shouldShowBanner && privacy.shouldShowBanner()) {
      document.addEventListener("visitorConsentCollected", startPopupTimers, { once: true });
    } else {
      startPopupTimers();
    }
    popup.querySelector("[data-nb-popup-sluit]").addEventListener("click", closePopup);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !popup.hidden) closePopup();
    });
    popup.querySelector("[data-nb-popup-form]").addEventListener("submit", function (e) {
      e.preventDefault();
      var input = popup.querySelector('input[type="email"]');
      if (!input.checkValidity()) { input.reportValidity(); return; }
      footerEmail.value = input.value.trim();
      // Gekozen dier(en) uit de pop-up overnemen in het footerformulier.
      popup.querySelectorAll("[data-nb-dier]").forEach(function (cb) {
        var doel = footerForm.querySelector('[data-nb-dier][value="' + cb.value + '"]');
        if (doel) doel.checked = cb.checked;
      });
      savePopup("aangemeld");
      if (footerForm.requestSubmit) footerForm.requestSubmit(); else footerForm.submit();
    });
  }
});
